import {Component} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Feature} from 'ol';
import {FeatureType} from 'src/app/models/EnumTypes';
import {NavaidModel} from 'src/app/models/navaid';
import {PopupAreaCoverageComponent} from 'src/app/popup/calculations/area-coverage/area-coverage.component';
import {
  PopupPerformanceCalculationComponent
} from 'src/app/popup/calculations/performance-calculation/performance-calculation.component';
import {CalculationValidation} from 'src/app/services/calculation-validation.service';
import {CalculationsService} from 'src/app/services/calculations.service';
import {ModalControlService} from 'src/app/services/modal-control.service';
import {PointsService} from 'src/app/services/points.service';
import {MenuManagementService} from '../services/menu-management.service';
import {CalculationsControlService} from 'src/app/services/calculations-control.service';
import {ImpactCalculationComponent} from "../../popup/grit/impact-calculation/impact-calculation.component";

@Component({
  selector: 'app-calculation-menu',
  templateUrl: './calculation-menu.component.html',
  styleUrls: ['./calculation-menu.component.scss'],
  standalone: false
})


// TODO: Navaid Validation Elevation. use facilityConfiguration.aboveTerrainLimitFT
export class CalculationMenuComponent {

  constructor(public menuService: MenuManagementService,
    public calculationService : CalculationsService,
    public calculationControlService : CalculationsControlService,
    private pointsController : PointsService,
    private modalService : ModalControlService,
    private popupService : BsModalService,
    protected calculationValidationService: CalculationValidation,
    ) {

  }


  validPerformanceFeatures( minNavaids: number, numProcedures: number): boolean {
    return (this.pointsController.getRNAVNavaids().length >= minNavaids
     && this.pointsController.getSelectedFeaturesOfType(FeatureType.Procedure).length  == numProcedures)

  }

  openAreaCoveragePopup(): void {
    if (this.pointsController.getSelectedFeatures().length >= 1) {
      let navaidsCounter = 0;
      this.pointsController.getSelectedFeatures().forEach((element) => {
        if (element.getProperties().featureType == FeatureType.Navaid
        && this.calculationControlService.validNavaidTypeForCoverageCalculation(this.pointsController.transformFeatureInNavaid(element)) ) {
          navaidsCounter++;
        }
      });
      if (navaidsCounter >= 1) {
        const bsModalRef : BsModalRef = this.popupService.show(PopupAreaCoverageComponent);
        bsModalRef.content.title = 'Coverage Options';
        bsModalRef.content.coverage_type = 'COVERAGE';
      } else {
        this.modalService.showMesssageModal(
          'Warning',
          'Please select at least 1 NavAids of type different from NDB and DME_ILS or omnidirectional DME_ILS with no bias.'
        );
      }
    } else {
      this.modalService.showMesssageModal(
        'Warning',
        'Please select at least 1 NavAids'
      );
    }

    // this.menuService.toogleMenu();
  }

  openAreaCumulativeCoveragePopup(): void {
    let selectedFeatures: Feature[] = this.pointsController.getSelectedFeatures();
    if (selectedFeatures.length >= 1) {
      let navaidsCounter = 0;
      selectedFeatures.forEach((element) => {
        if (element.getProperties().featureType == FeatureType.Navaid) {
          navaidsCounter++;
        }
      });
      if (navaidsCounter >= 1) {
        const bsModalRef : BsModalRef = this.popupService.show(PopupAreaCoverageComponent);
        bsModalRef.content.title = 'Cumulative Coverage Options';
        bsModalRef.content.coverage_type = 'CUMULATIVE_COVERAGE';
      } else {
        this.modalService.showMesssageModal(
          'Warning',
          'Please select at least 1 NavAids'
        );
      }
    } else {
      this.modalService.showMesssageModal(
        'Warning',
        'Please select at least 1 NavAids'
      );
    }
    //this.menuService.toogleMenu();
  }

  openAreaPerformancePopup(): void {
    const selectedFeatures: Feature[] = this.pointsController.getSelectedFeaturesOfType(FeatureType.Navaid);
    if (selectedFeatures.length == 0) {
      this.modalService.showMesssageModal(
        'Warning',
        'Please select at least 1 NavAid'
      );
      return;
    }

    this.popupService.show(PopupPerformanceCalculationComponent);
  }

  getInvalidNavaids(navaids: NavaidModel[]){
    return navaids.filter((navaid) => navaid.doc == null || navaid.elevation == null || navaid.maxaltitude == null)
  }

  async openVerticalProfilePopup(){
    this.calculationValidationService.openVerticalProfilePopupInitialization();
  }
  async openPerformanceAnalysisPopup(){
    this.calculationValidationService.openPerformanceAnalysisPopupInitialization()
  }

  //#region GRIT
  async openImpactCalculationPopup() {
    let devices = await this.pointsController.getGritSelected(FeatureType.Device)

    const bsModalRef : BsModalRef = this.popupService.show(ImpactCalculationComponent);
    bsModalRef.content.devices = devices;
    // bsModalRef.content.receivers = receivers;
    //
    //
    // if (this.pointsController.getSelectedFeatures().length >= 1) {
    //   let navaidsCounter = 0;
    //   this.pointsController.getSelectedFeatures().forEach((element) => {
    //     if (element.getProperties().featureType == FeatureType.Navaid
    //       && this.calculationControlService.validNavaidTypeForCoverageCalculation(this.pointsController.transformFeatureInNavaid(element)) ) {
    //       navaidsCounter++;
    //     }
    //   });
    //   if (navaidsCounter >= 1) {
    //     const bsModalRef : BsModalRef = this.popupService.show(PopupAreaCoverageComponent);
    //     bsModalRef.content.title = 'Coverage Options';
    //     bsModalRef.content.coverage_type = 'COVERAGE';
    //   } else {
    //     this.modalService.showMesssageModal(
    //       'Warning',
    //       'Please select at least 1 NavAids of type different from NDB and DME_ILS or omnidirectional DME_ILS with no bias.'
    //     );
    //   }
    // } else {
    //   this.modalService.showMesssageModal(
    //     'Warning',
    //     'Please select at least 1 NavAids'
    //   );
    // }
  }
  //endregion
}

